// Click-to-zoom overlay with mouse/touch pan (Dawn-style).
function createOverlay(image) {
  const overlay = document.createElement('div');
  overlay.setAttribute('class', 'image-magnify-full-size');
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
  overlay.style.backgroundRepeat = 'no-repeat';
  overlay.style.backgroundColor = 'rgb(var(--color-background))';
  image.parentElement.insertBefore(overlay, image);
  return overlay;
}

function moveWithHover(image, overlay, event) {
  const zoomRatio = 2;
  const ratio = image.height / image.width || 1;
  const container = overlay.getBoundingClientRect();
  const clientX = event.touches ? event.touches[0].clientX : event.clientX;
  const clientY = event.touches ? event.touches[0].clientY : event.clientY;
  const xPosition = Math.min(Math.max(clientX - container.left, 0), container.width);
  const yPosition = Math.min(Math.max(clientY - container.top, 0), container.height);
  const width = image.clientWidth || container.width || 1;
  const xPercent = `${(xPosition / width) * 100}%`;
  const yPercent = `${(yPosition / (width * ratio)) * 100}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${width * zoomRatio}px`;
}

function removeOverlay(overlay) {
  if (overlay && overlay.parentElement) overlay.remove();
}

function magnify(image, event) {
  // Replace any existing overlay first.
  image.parentElement.querySelectorAll('.image-magnify-full-size').forEach((el) => el.remove());

  const overlay = createOverlay(image);
  moveWithHover(image, overlay, event);

  const onMove = (moveEvent) => {
    if (moveEvent.cancelable) moveEvent.preventDefault();
    moveWithHover(image, overlay, moveEvent);
  };
  const onLeave = () => {
    cleanup();
    removeOverlay(overlay);
  };
  const onClick = () => {
    cleanup();
    removeOverlay(overlay);
  };

  const cleanup = () => {
    overlay.removeEventListener('mousemove', onMove);
    overlay.removeEventListener('mouseleave', onLeave);
    overlay.removeEventListener('click', onClick);
    overlay.removeEventListener('touchmove', onMove);
    overlay.removeEventListener('touchend', onLeave);
  };

  overlay.addEventListener('mousemove', onMove);
  overlay.addEventListener('mouseleave', onLeave);
  overlay.addEventListener('click', onClick);
  overlay.addEventListener('touchmove', onMove, { passive: false });
  overlay.addEventListener('touchend', onLeave);
}

function enableZoomOnHover() {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    if (image.dataset.magnifyBound === 'true') return;
    image.dataset.magnifyBound = 'true';
    image.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      magnify(image, event);
    });
  });
}

enableZoomOnHover();

// Re-bind after variant media gallery swaps / theme editor section reloads.
document.addEventListener('shopify:section:load', enableZoomOnHover);
document.addEventListener('variant:mediachange', enableZoomOnHover);
